import React from 'react';
import TodoMoviesList from '../Components/TodoMoviesList';

function TodoMovies() {
  return <TodoMoviesList />;
}

export default TodoMovies;
